<div class="container">
  <div class="sidebar">
  </div>
  <div class="content">
    @if(isLargeScreen){
    <div class="custom-tab-wrapper">
      <div class="tab" [class.active]="selectedTab === 'proforma'" (click)="selectedTab = 'proforma'">
        @if (selectedTab === 'proforma') {
        <span class="right-mark">✓</span>
        }
        <span i18n>Proforma Service Invoice</span>
      </div>
      <div class="tab" [class.active]="selectedTab === 'preview'" (click)="selectedTab = 'preview'">
        @if (selectedTab === 'preview') {
        <span class="right-mark">✓</span>
        }
        <span i18n>Preview Invoice</span>
      </div>
    </div>
    }
    @else {
    <div class="report-header">
      <h3 i18n>Proforma Service Invoice</h3>
      <p i18n>Please refer below the invoice details for your vehicle.</p>
    </div>
    }
    @if (selectedTab=='proforma') {
    @if(apiResponse?.serviceJobs?.length > 0){
    <div class="service-lines-container">
      <div class="service-lines-header">
        {{ serviceJobsLength | i18nPlural: jobMapping }}
      </div>
      <div class="service-lines-table-container">
        <table class="service-lines-table summary-table">
          @if (showFullList) {
          <thead>
            <tr class="table-header">
              <th class="description-column" i18n>Description</th>
              <th i18n class="amount-column">Amount</th>
            </tr>
          </thead>
          }
          <tbody>
            @if (showFullList) {
            @for (item of apiResponse?.serviceJobs; track item) {
            <tr class="service-line-row">
              <td class="description-column">
                @if (item.description?.trim() === 'Undefined') {
                <span i18n>Undefined</span>
                }
                @else {
                {{ item.description }}
                }
              </td>
              <td class="value">{{ item.price?.netPrice | currency: item.price?.currency: 'symbol-narrow' }}</td>
            </tr>
            }

            @for (line of automaticSurchargeLines; track line.id) {
            <tr class="service-line-row">
              <td class="description-column">
                {{ line.description }}
              </td>
              <td class="value">
                {{ line.price?.netPrice | currency: line.price?.currency : 'symbol-narrow' }}
              </td>
            </tr>
            }
            }
            <tr>
              <td colspan="2" class="see-details-link">
                <a href="#" (click)="toggleItemList($event)">
                  <ng-container *ngIf="showFullList" i18n>See less</ng-container>
                  <ng-container *ngIf="!showFullList" i18n>See details</ng-container>
                </a>

              </td>
            </tr>

            <tr>
              <td class="label" i18n>Total</td>
              <td class="value">
                {{ totalNetPrice | currency: currency: 'symbol-narrow' }}
              </td>
            </tr>
            <tr>
              <td class="label" i18n>Discount</td>
              <td class="value">
                {{ totalDiscount | currency: currency: 'symbol-narrow' }}
              </td>
            </tr>
            <tr>
              <td class="label" i18n>Tax</td>
              <td class="value">
                {{ totalVAT | currency: currency: 'symbol-narrow' }}
              </td>
            </tr>
            <tr class="total-incl">
              <td class="label bold" i18n>Total incl. tax</td>
              <td class="value bold">
                {{ totalGrossPrice | currency: currency: 'symbol-narrow' }}
              </td>
            </tr>

          </tbody>
        </table>
        @if(!isLargeScreen){
        <p class="pdf-note">
          <mat-icon class="info-icon">info</mat-icon>
          <span i18n>Download pdf to review details</span>
        </p>
        }
      </div>
    </div>
    }
    @else {
    <div class="no-data-wrapper">
      <div class="no-data-container">
        <img src="assets/logo/search_off.jpg" alt="No Data Available" />
        <div class="no-jobs-container">
          <h3 i18n>No Service Jobs Available</h3>
          <p i18n>No service Jobs found for this invoice.</p>
        </div>
      </div>
    </div>
    }
    }
    @if (selectedTab=='preview'){
    <div class="invoice-summary-pdf">
      @if (isPDFDataAvailable){
      <div class="pdf-wrapper">
        <app-pdf-canvas-viewer [base64]="pdfBase64Data">
        </app-pdf-canvas-viewer>
      </div>
      }

      @else {
      <div class="large-images">
        <img src="../../assets/logo/Frame 84.png" alt="File not found." i18n-alt />
      </div>
      }
    </div>
    }
    @if (apiResponse?.serviceJobs?.length>0) {
    <div class="footer">
      <div class="footer-content">
        <button class="request-callback-button" color="primary" mat-raised-button
          (click)="approvalConsent(Approvalstatus.NotProvided)">
          <img src="../../assets/common/request_callback.png" class="request_callback_image" />
          <span class="callback-text" i18n>Request Callback</span>
        </button>
        @if (showAuthorizeButton) {
        <button class="button-authorize" color="primary" mat-raised-button [disabled]="isAuthorizeDisabled"
          [ngClass]="{'disabled-button': isAuthorizeDisabled}" (click)="approvalConsent(Approvalstatus.Accept)">
          @if (isAuthorizeDisabled) {
          <ng-container i18n>Authorized</ng-container>
          } @else {
          <ng-container i18n>Authorize</ng-container>
          }
          <mat-icon>check</mat-icon>
        </button>
        }
      </div>

      <div class="action-bar-container responsive-actions">
        <button class="floating-center-btn" (click)="approvalConsent(Approvalstatus.NotProvided)">
          <img src="../../assets/common/callback.png" />
        </button>
        <div class="action-bar">
          <button mat-button class="decline-btn" color="primary" (click)="downloadPdf()">
            <mat-icon>download</mat-icon>
            <span i18n>Download</span>
          </button>
          @if (showAuthorizeButton) {
          <button mat-button class="authorize-btn" color="primary" [disabled]="isAuthorizeDisabled"
            [ngClass]="{'text-disabled': isAuthorizeDisabled}" (click)="approvalConsent(Approvalstatus.Accept)">
            @if (isAuthorizeDisabled) {
            <ng-container i18n>Authorized</ng-container>
            } @else {
            <ng-container i18n>Authorize</ng-container>
            }
            <mat-icon>check</mat-icon>
          </button>
          }
        </div>
      </div>
    </div>
    }
  </div>
</div>